<template>
  <div id="app" style="overflow-x:hidden;">
    <div>
      <sup-body></sup-body>
    </div>
    <!-- 回到顶部 -->
    <el-backtop></el-backtop>
  </div>
</template>

<script>
import SupBody from "./views/mainpage/SupBody.vue";
import api from "./api"; // 导入api接口
export default {
  components: {
    "sup-body": SupBody
  }
};
</script>

<style lang="scss">
body {
  background: #fbfbff;
  margin: 0px;
}
//修改滚动条样式
::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}
::-webkit-scrollbar-thumb {
  //滑块部分
  border-radius: 5px;
  background-color: #909399;
}
::-webkit-scrollbar-track {
  //轨道部分
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #ededed;
  border-radius: 5px;
}
</style>
